import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import ProjectManagement from './components/ProjectManagement';
import RecurringContracts from './components/RecurringContracts';
import CompanyManagement from './components/CompanyManagement';
import TaxReporting from './components/TaxReporting';
import Contract from './components/Contract';
// import Expenses from './components/Expenses';
import AccessCode from './components/AccessCode';
import { Home as HomeIcon, FolderOpen, Building2, FileText, Calculator, Repeat, LogOut } from 'lucide-react';

function Navigation({ onLogout }) {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: '홈', icon: HomeIcon },
    { path: '/projects', label: '프로젝트 관리', icon: FolderOpen },
    { path: '/recurring', label: '정기 계약', icon: Repeat },
    { path: '/companies', label: '업체 관리', icon: Building2 },
    // { path: '/expenses', label: '지출', icon: CreditCard },
    { path: '/contract', label: '계약서', icon: FileText },
    { path: '/tax-reporting', label: '세금 신고', icon: Calculator }
  ];

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-tabs">
          <Link to="/" className="nav-logo">
            <img src="/logo.png" alt="Loop Dimension" height="32" />
          </Link>
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-tab ${isActive ? 'active' : ''}`}
              >
                <Icon size={18} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </div>
        <button
          onClick={onLogout}
          className="nav-tab logout-button"
          title="로그아웃"
        >
          <LogOut size={18} />
        </button>
      </div>
    </nav>
  );
}

function App() {
  const [isAccessGranted, setIsAccessGranted] = useState(() => {
    // Check if user is already logged in from localStorage
    return localStorage.getItem('loopBudgetAccess') === 'granted';
  });

  const handleAccessGranted = () => {
    setIsAccessGranted(true);
    // Store the access status in localStorage
    localStorage.setItem('loopBudgetAccess', 'granted');
  };

  const handleLogout = () => {
    setIsAccessGranted(false);
    // Remove the access status from localStorage
    localStorage.removeItem('loopBudgetAccess');
  };

  if (!isAccessGranted) {
    return <AccessCode onAccessGranted={handleAccessGranted} />;
  }

  return (
    <Router>
      <div className="App">
        <Navigation onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<ProjectManagement />} />
            <Route path="/recurring" element={<RecurringContracts />} />
            <Route path="/companies" element={<CompanyManagement />} />
            <Route path="/tax-reporting" element={<TaxReporting />} />
            <Route path="/contract" element={<Contract />} />
            {/* <Route path="/expenses" element={<Expenses />} /> */}
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
